<div>
  <div class="text-primary">
    <i eIcon icon="desktop"></i>
    Volgende device types
  </div>
  <hr class="my-2" />
  <ul>
    @for (d of feature.requiredDeviceTypes; track d) {
      <li>
        {{ d }}
      </li>
    }
  </ul>
</div>
